import { type FC } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import clsx from "clsx";

import Spacing from "@/shared/components/ui/Spacing";
import { useAdminBackground } from "@/core/hooks/useAdminBackground";
import styles from "../AdminBackgroundLayout/AdminBackgroundLayout.module.scss";
import AdminDashboardHeader from "@/shared/components/admin/AdminDashboardHeader/AdminDashboardHeader";
import { useAppSelector } from "@/store/hooks";
import { getUser } from "@/store/slices/auth";
const AdminAuthLayout: FC = () => {
  const user = useAppSelector(getUser);
  const navigate = useNavigate();
  // Get background styles and state
  const { backgroundStyles, isImageLoaded } = useAdminBackground();

  // const handleLogout = (): void => {
  //   // Remove cookie
  //   navigate("/");
  // };

  if (
    user &&
    user.role === "super_admin" &&
    user.isYubiKeyEnabled &&
    user.isYubiKeyAuthenticated
  ) {
    navigate("/dashboard");
  }

  console.log("isImageLoaded", isImageLoaded);
  return (
    <Spacing
      className={clsx(styles.layout, {
        [styles.imageLoaded]: isImageLoaded,
      })}
      style={backgroundStyles}
      display="flex"
      direction="column"
      height="100vh"
    >
      <div className={styles.gradientOverlay} />
      <AdminDashboardHeader isRightSectionShown={false} />

      {/* Content container that takes remaining space */}
      <Spacing
        display="flex"
        className={styles.contentContainer} // Add this class
      >
        {/* <AdminSidebar onLogout={handleLogout} /> */}
        <Spacing as="main" className={styles.main}>
          <Outlet />
        </Spacing>
      </Spacing>
    </Spacing>
  );
};

export default AdminAuthLayout;
